<app-loader></app-loader>
<div class="modify-model">
    <div class="payment-option">
        <h4>Spot Count Update</h4>
        <div class="custom-close">
            <img src="../../assets/images/new-close.svg" (click)="closeDialog()" alt="Close"/>
        </div>
    </div>
    <div class="parker-body-text" *ngIf="errorMessage">
        <div class="information-icon">
            <h4 class="fill-error">{{errorMessage}}</h4>
        </div>
    </div>
    <div class="booked-text">
        <p>You’re currently booked for {{ bookingDetails.spotCount }} {{bookingDetails.spotCount > 1 ?
            'spots.' : 'spot.'}}<br />Set new total spot count:</p>
    </div>

    <div class="modify-output date-filter">
        <form [formGroup]="spotCountUpdateForm">
            <div class="date-outer">
                <div class="custom-select2 custom-date-calender spot-count">
                    <p-inputNumber formControlName="spots" [showButtons]="true" buttonLayout="horizontal"
                        spinnerMode="horizontal" inputId="vertical" [decrementButtonClass]="(spotCountUpdateForm.get('spots')?.value > 1 ? 'p-button-secondary' : 'custom-decrement')"
                        incrementButtonClass="p-button-secondary" [min]="1" incrementButtonIcon="pi pi-plus"
                        decrementButtonIcon="pi pi-minus" />
                </div>
            </div>
            <div *ngIf="bookingDetails.bookingType === bookingTypeDetailsEnum.Recurring" class="date-outer common-spot">
                <label for="spots">Select Billing Cycle<span class="custom-star">*</span></label>
                <div class="custom-select2 custom-date-calender"
                   >
                    <p-dropdown id="spots" [options]="bookingCycleOption" formControlName="bookingCycle"
                        appendTo="body"  placeholder="Select" class="w-full mt-1"></p-dropdown>
                    <img src="../../../../assets/images/fill-dropdown.svg" alt="" />
                    <div class="error-outer">
                        <div
                            *ngIf="spotCountUpdateForm.get('bookingCycle')?.hasError('required')  && (spotCountUpdateForm.get('bookingCycle')?.dirty || spotCountUpdateForm.get('bookingCycle')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="save-btn">
                <p-button type="Submit" label="Next" [class.disabled-label]="spotCountUpdateForm.value.bookingCycle === bookingCycleOptionEnum.Current &&  isButtonDisable" (onClick)="spotCountUpdateForm.value.bookingCycle === bookingCycleOptionEnum.NextBillingCycle ?nextBillingCycleSpotChange(): checkSoptCountAvaility()"></p-button>
            </div>
              <div class="spot-note">
               <h5><strong>Note: </strong>Current billing cycle spot count will be applied to the next cycle by default, unless explicitly modified.</h5>
             </div>
        </form>
    </div>
</div>